import moment from 'moment';

export function TimeUsed(payload: { timeStart: Date, timeEnd: Date }) {
  let text = ``;
  let minute = moment(payload.timeEnd).diff(payload.timeStart, 'minute');
  let hours = moment(payload.timeEnd).diff(payload.timeStart, 'hours');
  let days = moment(payload.timeEnd).diff(payload.timeStart, 'days');

  if (days) {
    text += `${days} วัน. `;
  }
  if (hours) {
    text += `${hours - (days * 24)} ชม. `;
  }
  if (minute) {
    text += `${minute - (hours * 60)} นาที `;
    if (hours) {
      text += `\n(${minute} นาที)`
    }
  } else {
    text += `เมื่อสักครู่`
  }
  return text;
}
